import { jsx as _jsx } from "react/jsx-runtime";
import { HcList } from '@hotmart-org-ca/cosmos-web/dist/react/hc-list';
import { ListItem } from './item';
export function List({ children }) {
    return (_jsx(HcList, { style: {
            '--hc-list-item-border-width': 0,
            '--hc-list-item-background-color': 'transparent',
            '--hc-list-item-padding': '0 var(--hc-size-spacing-5)',
            '--hc-list-item-margin-bottom': 'var(--hc-size-spacing-3)'
        }, children: children }));
}
List.Item = ListItem;
